import { ReactNode } from "react"
import AuthenticatedSidebar from "@/modules/layout/ui/navbar/AuthenticatedSidebar"
import AuthenticatedNavbar from "@/modules/layout/ui/navbar/AuthenticatedNavbar"
import { OrganizationLoader } from "@/modules/layout/ui/components/OrganizationLoader"
import { CvUploadProvider } from "@/modules/recruitment/context/CvUploadContext"
import { DocPushProvider } from "@/modules/sage300/context/DocPushContext"
import { BulkRejectionProvider } from "@/modules/recruitment/context/BulkRejectionContext"
import { BulkVideoProvider } from "@/modules/recruitment/context/BulkVideoContext"
import { BulkAiCallProvider } from "@/modules/recruitment/context/BulkAiCallContext"
import { PluginInstallsProvider } from "@/modules/marketplace/context/PluginInstallsContext"

interface EmployeeLayoutProps {
  children: ReactNode
}

// AuthenticatedSidebar and AuthenticatedNavbar consume these contexts
// unconditionally, so employee routes must supply them even though the
// underlying features are admin-only. usePluginInstalls throws without its
// provider, which blanks the whole app (there is no error boundary).
export default function EmployeeLayout({ children }: EmployeeLayoutProps) {
  return (
    <OrganizationLoader>
      <CvUploadProvider>
        <DocPushProvider>
          <BulkRejectionProvider>
            <BulkVideoProvider>
              <PluginInstallsProvider>
                <BulkAiCallProvider>
                  <div className="flex h-screen bg-layout-bg">
                    <AuthenticatedSidebar />
                    <div className="flex-1 flex flex-col overflow-clip">
                      <AuthenticatedNavbar />
                      <main className="flex-1 overflow-x-hidden overflow-y-auto bg-layout-bg">
                        {children}
                      </main>
                    </div>
                  </div>
                </BulkAiCallProvider>
              </PluginInstallsProvider>
            </BulkVideoProvider>
          </BulkRejectionProvider>
        </DocPushProvider>
      </CvUploadProvider>
    </OrganizationLoader>
  )
}
